export const miscEndpoints = {
  GET_REGIONS: '/regions/',
  GET_COUNTRIES: '/countries/',
  GET_MODALITIES: '/modalities/',
  GET_CHAINS: '/chains/',
}
